import { render, staticRenderFns } from "./sub-header.vue?vue&type=template&id=176eb0ca&scoped=true&lang=pug&"
import script from "./sub-header.vue?vue&type=script&lang=js&"
export * from "./sub-header.vue?vue&type=script&lang=js&"
import style0 from "./sub-header.vue?vue&type=style&index=0&id=176eb0ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176eb0ca",
  null
  
)

export default component.exports